import {DealsDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_DEAL';

export async function createDeal(
    userData: Record<string, string>,
    newDeal: Record<string, any>
) {

    try {
        const result = await DealsDao.createDeal(userData.userToken, newDeal);

        return result;
    }

    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur lors de la création de l\'affaire',
            error: error
        });
    }
}
